const getDefaultState = () => {
  return {
    label: 'Add to cart',
    icon: 'mdi mdi-cart',
    class: 'error',
    loading: false,
    complete: false,
    continueOrder: false,
  }
}

// initial state
const state = getDefaultState()

// getters
const getters = {
  getButton(state) {
    return state
  },
  getContinueOrder(state) {
    return state.continueOrder
  },
}
// mutations
const mutations = {
  setAddToCart(state) {
    state = getDefaultState()
  },
  setContinueOrder(state, val) {
    state.continueOrder = val
  },
  setAddedToCart(state) {
    state.label = 'Added to cart'
    ;(state.icon = 'mdi mdi-check'), (state.class = 'success')
    state.loading = false
    state.continueOrder = null
  },
  setComplete() {
    state.complete = true
  },
  setSaveCart(state) {
    // TODO:  replace button values
  },
  startLoader(state) {
    state.loading = true
  },
  endLoader(state) {
    state.loading = false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
}
